<template>
<div>
    <div class='q-ma-md' >
        <div class="main_container q-pa-md row wrap q-subheading bg-blue-1 shadow-1 ellipsis items-center">
                <div class="q-title items-center q-mt-md ellipsis" v-if='stanokInfo.length == 0'>В работе ничего нет</div>
                    <div v-if='stanokInfo.length != 0' class='row full-width'>
                        <div>
                            <div class='bg-secondary row q-mb-md text-white q-pa-xs q-caption items-baseline ellipsis' style="width:450px">
                                <i class="fas fa-info-circle q-mr-xs"/>по направлениям<i class="fas fa-angle-right q-ml-xs"/>
                            </div>
                            <div class=" q-mr-lg stanokField" >                
                                <div v-for='(item, key) in stanokInfo' :key = key class='row no-wrap q-mb-xs stanokField'  v-on:click='setStanokFilter(key)'>
                                    <div class="ellipsis underLine" style='width:330px'>
                                        {{ getStanokName(key) }}
                                    </div>
                                    <div class="ellipsis underLine " style='width:120px; text-align:right;'>
                                        {{item}} <span class='text-light q-caption'>кв.м.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class='bg-secondary row q-mb-md text-white q-pa-xs q-caption items-baseline ellipsis' style="width:450px">
                                <i class="fas fa-info-circle q-mr-xs "/>по материалам<i class="fas fa-angle-right q-ml-xs" />
                            </div>
                            <div class="">
                                <div v-for='(item, key) in materialInfo' :key = key  class='row q-mb-xs no-wrap  stanokField' v-on:click='setMaterialFilter(key)'>
                                    <div class="ellipsis underLine" style='width:330px'>
                                        {{ getMaterialName(key) }}
                                    </div>
                                    <div class="ellipsis underLine" style='width:120px; text-align:right;'>
                                        {{item}}  <span class='text-light q-caption'>кв.м.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>           
        </div>
    </div>


</div>
</template>


<script>
/* eslint-disable */
export default {

    name : 'managerInfo',

    created() {
        this.$store.dispatch('getInWorkInfo');
    },

    computed : {
        stanokInfo() {
            return this.$store.getters.getStanokInfo;
        },
        materialInfo() {
            return this.$store.getters.getMaterialInfo;
        },
    },

    methods :{
        getInfo() {
            this.$store.dispatch('getInWorkInfo');
        },
        
        getStanokName(id) {            
            let q = this.$store.getters.getDirectionById(id);
            if (q == null) return '';
            return  q.name;
        },
        
        getMaterialName(id) {
            let q = this.$store.getters.getMaterialById(id);
            if (q == null) return '';
            return  q.name;
        },
    }

}
</script>
<style lang="scss" scoped>
    .main_container {
        border : 1px solid rgb(214, 214, 214);
        border-radius: 5px;
    }
    .underLine {
        border-bottom : 1px solid rgb(143, 143, 143);
        cursor: default;
    }
</style>

